// コラム詳細・資料ダウンロード詳細の本文用
// 表のスタイル「SP で縦に組み替え」: 各セルに列の見出し（data-label）を付ける。
// 対象の表がないページでは何もしない。計画・経緯: docs/09_article_body_redesign.md
document.addEventListener('DOMContentLoaded', function () {
  var tables = document.querySelectorAll('figure.wp-block-table.is-style-stack table');
  Array.prototype.forEach.call(tables, function (table) {
    var headRow = table.querySelector('thead tr');
    var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));
    if (!headRow && rows.length > 1) {
      // 見出し行の設定がない表は、1行目を見出しとして扱う
      headRow = rows.shift();
      headRow.classList.add('ab-stackHead');
    }
    if (!headRow) {
      return;
    }
    var labels = Array.prototype.map.call(headRow.children, function (cell) {
      return cell.textContent.replace(/\s+/g, ' ').trim();
    });
    rows.forEach(function (row) {
      Array.prototype.forEach.call(row.children, function (cell, i) {
        if (i > 0 && labels[i]) {
          cell.setAttribute('data-label', labels[i]);
        }
      });
    });
  });
});
